export const getName = (firstName, lastName, fallbackField) => {
  let result = '';

  if (firstName && lastName) {
    result = `${lastName}, ${firstName}`;
  } else if (firstName && !lastName) {
    result = firstName;
  } else if (!firstName && lastName) {
    result = lastName;
  } else {
    result = fallbackField;
  }

  return result;
};

export const getPhysicianName = (firstName, lastName, fallbackField) => {
  if (firstName && typeof firstName !== 'string')
    throw new TypeError('firstName must be a string');

  if (lastName && typeof lastName !== 'string')
    throw new TypeError('lastName must be a string');

  const firstLetter = firstName ? firstName.charAt(0).toUpperCase() : '';
  return getName(firstLetter, lastName, fallbackField);
};

/**
 * Given a person data object and a matchValue string, identify if any parts of the value is in the list.
 * @param personData
 * @param matchValue
 * @returns {boolean}
 */
export const doesValueMatchPersonData = (personData, matchValue) => {
  if (matchValue && typeof matchValue !== 'string') throw new TypeError();
  const fields = `${personData.lastName}, ${personData.firstName} ${personData.customParticipantID}`.toLowerCase();
  if (matchValue.trim() === '' && fields !== '') return false;

  const searchInputParts = matchValue.toLowerCase().split(' ');
  return searchInputParts.every(text => fields.includes(text));
};



// WEBPACK FOOTER //
// ./src/common/personUtils.js